module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av224-1303b655c8609711d985b12184cd5215.jpg";